import { cn } from "@/common/utils/cn.util"

/**
 * Loading spinner — a pure-CSS gray ring.
 *
 * Replaces the former lottie-web animation, which pulled an ~80 kB chunk (and a
 * runtime `eval` from lottie's expression engine) onto first paint for what is
 * just a spinner. Mirrors the shared `Loaders/Spinner` pattern (animate-spin
 * ring + reduced-motion fallback), kept gray to match the prior animation.
 *
 * Size and color via `className` (defaults: 1rem, gray-400); `cn` lets callers
 * override cleanly — including the radius, which a bare `twMerge` could not
 * resolve because it knows nothing about the `nx-*` scales.
 *
 * Decorative (`aria-hidden`): like the lottie view it replaces, it carries no
 * a11y semantics. The loading *state* is announced by the surrounding context
 * (status regions, button labels, "Loading…" text) — a `role="status"` here
 * would nest a second live region inside those and double-announce.
 */
export const Loader = ({ className }: { className?: string }) => (
  <span
    aria-hidden="true"
    className={cn(
      "rounded-nx-full text-nx-text-tertiary inline-block h-4 w-4 animate-spin border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]",
      className
    )}
  />
)
